import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { API_URL } from '@/config';
import errModal from '@/mixins/showDialogError';
import store from '@/store';

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        Vue.axios.defaults.withCredentials = true;
        Vue.axios.defaults.xsrfCookieName = 'csrftoken';
        Vue.axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
        Vue.axios.interceptors.request.use((config) => {
            const refCode = localStorage.getItem('ref_code');

            if (refCode) {
                config.headers['ref-code'] = refCode;
            }

            return config;
        });


    },
    get(url, loader = false, showErrModal = true) {
        if (loader) {
            store.dispatch('loader/setLoading', true);
        }
        return Vue.axios
            .get(url)
            .then((response) => {
                // if (loader) {
                //     store.dispatch('loader/setLoading', false);
                // }
                return response;
            })
            .catch((error) => {
                // if (loader) {
                //     store.dispatch('loader/setLoading', false);
                // }
                if (showErrModal) {
                    errModal.showDialogError(error.response.data);
                }

                throw error.response;
            });
    },
    post(url, payload, showErrModal = true) {
        return Vue.axios
            .post(url, payload)
            .catch((error) => {
                if (showErrModal) {
                    errModal.showDialogError(error.response.data);
                }
                throw error.response;
            })
    },
    put(url, payload) {
        return Vue.axios
            .put(url, payload)
            .catch((error) => {
                errModal.showDialogError(error.response.data);
                throw error.response;
            })
    },
    patch(url, payload) {
        return Vue.axios
            .patch(url, payload)
            .catch((error) => {
                errModal.showDialogError(error.response.data);
                throw error.response;
            })
    },
    delete(url) {
        return Vue.axios
            .delete(url)
            .catch((error) => {
                errModal.showDialogError(error.response.data);
                throw error.response;
            })
    },

};

ApiService.init();
export default ApiService;
